import { ReactNode } from "react";
import { toCssClass } from "../Utils";

interface IFieldParams {
    label: string;
    children: ReactNode;
    onClick?: () => void;
}

export default function Field(props: IFieldParams) {

    if (!props.children && props.children !== 0)
        return null;
         
    return (
        <div onClick={props.onClick} className={"field " + toCssClass(props.label)} >
            <label>{props.label}</label>
            <span>{props.children}</span>
        </div>
    );
}